import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { RxCross2 } from "react-icons/rx"
import { AiOutlinePlus } from "react-icons/ai"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"

const QuoteSend = () => {
    const [fromEmail, setFromEmail] = useState("")
    const [fullName, setFullName] = useState("")
    const [quote, setQuote] = useState(undefined)
    const [totalAmount, setTotalAmount] = useState(0)
    const [recepients, setRecepients] = useState([])
    const [addRecepientPopup, setAddRecepientPopup] = useState(false)
    const [addRecepientInput, setAddRecepientInput] = useState("")
    const [subjectInput, setSubjectInput] = useState("")
    const [sendLoading, setSendLoading] = useState(false)

    const _crm__token = localStorage.getItem("_crm__token")

    const navigate = useNavigate()

    const { hash } = useParams()

    const fetchEmailAddress = async () => {
        const { data, status } = await axios.post(`${api}/Mailbox/email-address`, { token: _crm__token })

        if (data.success) {
            setFullName(data.name)
            setFromEmail(data.email)
        }
        // Redirect to mailbox - auth token expired
        else if (data.redirect) {
            navigate("/mailbox")
        }
    }

    const calcualteTotal = (quote) => {
        let total = 0

        const items = quote.items

        items.forEach(item => {
            total += (item.quantity * item.rate)
        })

        if (quote.discount) {
            if (quote.discount.ispercentage) {
                total = total - (total * quote.discount.value / 100)
            } else {
                total = total - quote.discount.value
            }
        }

        if (quote.adjustment) {
            total = total + quote.adjustment.value
        }

        let tax = 0

        if (quote.taxdetails) {
            tax = total * quote.taxdetails.rate / 100
        }

        total = total + tax

        return total
    }

    const fetchQuote = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-quote`, { token: _crm__token, hash })

        if (data.success) {
            const total = calcualteTotal(data.quote)

            setQuote(data.quote)
            setTotalAmount(total)
            setRecepients(prev => {
                const copy = JSON.parse(JSON.stringify(prev))
                copy.push({
                    name: data.quote.customer.firstname + " " + data.quote.customer.lastname,
                    email: data.quote.customer.email,
                    protected: true
                })
                return copy
            })
        }
    }

    const quoteSend = async () => {
        setSendLoading(true)

        const { data, status } = await axios.post(`${api}/Accounting/send-quote`, { 
            token: _crm__token, 
            hash,
            subject: subjectInput ? subjectInput : `Quote - QT-${String(quote.quoteindex).padStart(6, "0")} is awaiting your approval`,
            recepients
        })

        setSendLoading(false)

        if (data.success) {
            navigate("/accounting/quotes")
        } else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchEmailAddress()
    }, [])

    useEffect(() => {
        fetchQuote()
    }, [hash])

    console.log({ quote })

    if (quote === undefined) {
        return (
            <div>Loading...</div>
        )
    }

    return (
        <div className="_9yme">
            {addRecepientPopup ? (
                <div className="likes-are" onClick={() => setAddRecepientPopup(false)}>
                    <div className="imbiber-wig" onClick={e => e.stopPropagation()}>
                        <span>Add new recepient</span>
                        <input
                            placeholder="Enter recepient e-mail address"
                            value={addRecepientInput}
                            onChange={e => setAddRecepientInput(e.target.value)}
                        />
                        <div>
                            <button onClick={() => {
                                setRecepients(prev => {
                                    const copy = JSON.parse(JSON.stringify(prev))
                                    copy.push({ email: addRecepientInput })
                                    return copy
                                })
                                setAddRecepientPopup(false)
                                setAddRecepientInput("")
                            }}>Add</button>
                            <button onClick={() => {
                                setAddRecepientPopup(false)
                                setAddRecepientInput("")
                            }}>Cancel</button>
                        </div>
                    </div>
                </div>
            ) : undefined}
            
            <div className="container">
                <div className="email_to">
                    <h3>Email to {quote.customer.firstname}</h3>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">From</div>
                    <div>
                        {fullName} &#x3C;{fromEmail}&#x3E;
                    </div>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">Send To</div>
                    <div className="outlying-swan">
                        {recepients.map((item, recepientIndex) => {
                            return (
                                <div key={recepientIndex} className="predry-wean">
                                    <div>{item.name}</div>
                                    {item.name ? (
                                        <span>
                                            &#x3C;{item.email}&#x3E;
                                        </span>
                                    ) : (
                                        <span>{item.email}</span>
                                    )}
                                    {item.protected ? undefined : (
                                        <span className="satiable-zip" onClick={() => setRecepients(prev => {
                                            const copy = JSON.parse(JSON.stringify(prev))
                                            copy.splice(recepientIndex, 1)

                                            return copy
                                        })}>
                                            <RxCross2 />
                                        </span>
                                    )}
                                </div>
                            )
                        })}
                        <div className="rodeos-ice" onClick={() => setAddRecepientPopup(true)}>
                            <AiOutlinePlus />
                        </div>
                    </div>
                </div>
                <div className="swizzle-gale">
                    <div className="from_">Subject</div>
                    <div className="input_">
                        <input  
                            placeholder={`Quote - QT-${String(quote.quoteindex).padStart(6, "0")} is awaiting your approval`}
                            value={subjectInput}
                            onChange={e => setSubjectInput(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="lactates-pole">
                <div className="header">
                    Quote #QT-{String(quote.quoteindex).padStart(6, "0")}
                </div>
                <div className="content">
                    <div className="line">
                        Dear {quote.customer.firstname},
                    </div>
                    <div className="line">
                        Thank you for contacting us. Your quote can be viewed, printed and downloaded as PDF from the link below.
                    </div>
                    <div className="candy-axed">
                    <div className="candy-axed_">
                            QUOTE AMOUNT
                        </div>
                        <div className="candy-axed_amount">
                            {quote.customer.currency.icon}{(Math.round(totalAmount * 100) / 100).toFixed(2)}
                        </div>
                    </div>
                    <div className="grandads-hags">
                        <div className="grandads-hags_">
                            <div className="pistil-haze">Quote Number</div>
                            <span>QT-{String(quote.quoteindex).padStart(6, "0")}</span>
                        </div>
                        <div className="grandads-hags_">
                            <div className="pistil-haze">Quote Date</div>
                            <span>{new Date(quote.quotedate).toDateString()}</span>
                        </div>
                        <div className="wrestled-ante">
                            <button>View Invoice</button>
                        </div>
                    </div>
                    <div className="regards">
                        Regards,
                        <div>{fullName}</div>
                    </div>
                </div>
            </div>
            <div className="repute-has">
                <button className="ballroom-tab" onClick={() => quoteSend()}>
                    {sendLoading ? <SpinnerCircular size="14" color="white" /> : "Send"}
                </button>
                <button className="satin-net" onClick={() => navigate("/accounting/quotes")}>
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default QuoteSend
